<template>
  <div>
    <v-row no-gutters justify="space-between">
      <div class="text-h5 font-weight-bold black--text mb-4">
        <translate>My Profile</translate>
      </div>
      <!-- <div class="actionSection ml-4">
        <ButtonEdit text="Edit all" @click="editAllToggle" v-if="editAll" />
      </div> -->
    </v-row>
    <v-card>
      <v-row no-gutters class="wrapperContent">
        <v-col cols="12">
          <v-row no-gutters align="center" class="mb-md-4">
            <v-col :md="2" cols="6" class="mb-4"
              ><div class="text-h6 grey82">
                <translate>Account</translate>
              </div></v-col
            >
            <v-col :md="10" cols="4" class="mb-4">
              <div class="actionSection ml-4">
                <ButtonEdit
                  @click="edit.account = true"
                  v-show="!edit.account"
                />
              </div>
            </v-col>

            <v-col cols="12" v-if="edit.account">
              <ProfileAccount
                :hide-submit="!editAll"
                ref="profile-account"
                @cancel="edit.account = false"
                @submit="onSubmit"
                :email="user.email"
              />
            </v-col>
            <template v-else>
              <v-col cols="12" :md="2" class="mb-4">
                <div class="text-body-2 font-weight-bold">
                  <translate>Email:</translate>
                </div>
              </v-col>
              <v-col cols="12" :md="10" class="mb-4">
                <p class="mb-0">{{ user.email }}</p>
              </v-col>
              <v-col cols="12" :md="2" class="mb-4"
                ><div class="text-body-2 font-weight-bold">
                  <translate>Password:</translate>
                </div></v-col
              >
              <v-col cols="12" :md="10" class="mb-4">
                <p class="mb-0">*************</p>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row no-gutters class="wrapperContent">
        <v-col cols="12">
          <v-row no-gutters align="center" class="mb-md-4">
            <v-col cols="6" :md="2" class="mb-4"
              ><div class="text-h6 grey82">
                <translate>Information</translate>
              </div></v-col
            >
            <v-col cols="6" :md="10" class="mb-4">
              <div class="actionSection ml-4">
                <ButtonEdit
                  @click="edit.infomation = true"
                  v-show="!edit.infomation"
                />
              </div>
            </v-col>

            <v-col cols="12" v-if="edit.infomation">
              <ProfileInfomation
                ref="profile-infomation"
                :hide-submit="!editAll"
                @cancel="edit.infomation = false"
                @submit="onSubmit"
                :first-name="user.firstName"
                :last-name="user.lastName"
                :phone="user.phone"
                :countryData="user.country"
                :state="user.state"
                :city="user.city"
                :handicap="user.handicap"
                :sub-roles="user.subRoles"
                :sub-roles-list="subRolesList"
              />
            </v-col>
            <template v-else>
              <v-col cols="12" class="mb-4">
                <v-row v-if="user.subRoles">
                  <template v-for="(checkbox, index) in subRolesList">
                    <v-col
                      cols="6"
                      sm="4"
                      lg="3"
                      :key="index"
                      v-if="user.subRoles.includes(checkbox.id)"
                      class="py-0"
                    >
                      <v-checkbox
                        class="margin-top-checkbox mb-md-4 mb-3"
                        :label="checkbox.name"
                        v-model="user.subRoles"
                        :value="checkbox.id"
                        readonly
                        hide-details="auto"
                      ></v-checkbox>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>First Name</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.firstName }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>Last Name</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.lastName }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>Phone</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.phone }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>Country</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.country }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>State</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.state }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>City</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.city }}</span>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>Languages</translate>:
                </span>
                <v-chip
                  class="mr-2"
                  color="primary"
                  outlined
                  small
                  v-for="val in languages"
                  :key="val.id"
                >
                  {{ val.name }}
                </v-chip>
              </v-col>
              <v-col :md="4" :sm="6" cols="12" class="mb-4">
                <span class="text-body-2 font-weight-bold text-capitalize mr-4">
                  <translate>Handicap</translate>:
                </span>
                <span class="text-body-2">{{ userInfomation.handicap }}</span>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row no-gutters class="wrapperContent">
        <v-col cols="12">
          <v-row no-gutters align="center" class="mb-md-4">
            <v-col :md="2" cols="6" class="mb-4"
              ><div class="text-h6 grey82">
                <translate>Social networks</translate>
              </div></v-col
            >
            <v-col :md="10" cols="4" class="mb-4">
              <div class="actionSection ml-4">
                <ButtonEdit
                  @click="edit.socials = true"
                  v-show="!edit.socials"
                />
              </div>
            </v-col>
            <v-col cols="12" class="mb-4" v-if="edit.socials">
              <ProfileSocials
                ref="profile-socials"
                :hide-submit="!editAll"
                :facebook-url="user.facebookUrl"
                :instagram-url="user.instagramUrl"
                :twitter-url="user.twitterUrl"
                :youtube-url="user.youtubeUrl"
                @cancel="edit.socials = false"
                @submit="onSubmit"
              />
            </v-col>
            <v-col cols="12" class="mb-4" v-else>
              <RowIconSocial :data="user" justify="justify-start"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider v-if="!editAll"></v-divider>
      <v-row v-if="!editAll">
        <v-col cols="12" class="ma-8">
          <v-btn
            large
            @click="editAllToggle"
            class="font-weight-bold elevation-0 text-none subtitle-1 mr-3"
          >
            <translate>Cancel</translate>
          </v-btn>
          <v-btn
            large
            type="submit"
            color="primary"
            @click.prevent="onSubmitAll"
            class="font-weight-bold elevation-0 text-none subtitle-1"
          >
            <translate>Save</translate>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import RowIconSocial from "@/components/RowIconSocial";
import ButtonEdit from "@/components/Buttons/ButtonEdit";
//form
import ProfileAccount from "@/components/Forms/ProfileAccount";
import ProfileInfomation from "@/components/Forms/ProfileInfomation";
import ProfileSocials from "@/components/Forms/ProfileSocials";
import { toFixedNumber } from "@/utils/helper";

export default {
  name: "MyProfile",
  components: {
    RowIconSocial,
    ButtonEdit,
    ProfileAccount,
    ProfileInfomation,
    ProfileSocials,
  },
  data: () => ({
    editAll: true,
    edit: {
      account: false,
      infomation: false,
      socials: false,
    },
  }),
  computed: {
    ...mapState("stepper", {
      subRolesList: "subRolesList",
    }),
    ...mapState("location", {
      languages: "languages",
    }),
    user() {
      return this.$store.state.auth.user;
    },
    userInfomation() {
      if (this.user) {
        let data = {
          firstName: this.user.firstName || "",
          lastName: this.user.lastName || "",
          phone: this.user.phone || "",
          language: this.user.language || "",
          city: this.user.city || "",
          state: this.user.state || "",
          handicap: toFixedNumber(this.user.handicap || 0, 1),
        };
        if (this.user.country) {
          data.country = this.user.country.name || "";
        }
        return data;
      }
      return {};
    },
  },
  methods: {
    editAllToggle() {
      let temp = !this.editAll;
      this.editAll = temp;
      this.edit = {
        account: !temp,
        infomation: !temp,
        socials: !temp,
      };
    },
    editAccount() {
      this.edit.account = !this.edit.account;
      // console.log(this.edit.account);
    },
    async onSubmit(info) {
      let result = null;

      if (info.type == "account") {
        result = await this.$store.dispatch("accountUpdate", info.data);
        this.edit.account = false;
      } else if (info.type == "infomation") {
        let output = { ...info.data };
        output.country = output.country.id; //set countryCode
        result = await this.$store.dispatch("profileUpdate", output);
        this.edit.infomation = false;
      } else if (info.type == "socials") {
        result = await this.$store.dispatch("profileUpdate", info.data);
        this.edit.socials = false;
      }

      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.$toast.success(this.$gettext(`Update success`));
        if (info.type == "account") {
          // save token
          this.$store.commit("setTokenData", result.newPassword);
        } else {
          this.$store.commit("setUserData", info.data);
        }
      }
    },
    async onSubmitAll() {
      let accountDone, infomationDone, socialsDone;

      // submit account
      let accountForm = this.$refs["profile-account"];
      if (accountForm) accountDone = await accountForm.onSubmit();

      // submit infomation
      let infomationForm = this.$refs["profile-infomation"];
      if (infomationForm) infomationDone = await infomationForm.onSubmit();

      // submit socials
      let socialsForm = this.$refs["profile-socials"];
      if (socialsForm) socialsDone = await socialsForm.onSubmit();

      console.log(accountDone, infomationDone, socialsDone);
      if (accountDone && infomationDone && socialsDone) {
        this.editAllToggle();
      }
    },
    formatName(name) {
      return name.replace(/([A-Z])/g, " $1").trim();
    },
  },
};
</script>

<style scoped lang="scss" >
.wrapperContent {
  padding: 36px 36px 8px;
}
.grey82 {
  color: #828282;
}
.actionSection {
  button {
    color: #179d4e;
    font-size: 15px;
    line-height: 20px;
  }
}
.theme--light.v-label--is-disabled {
  color: #000;
  font-size: 15px;
  line-height: 20px;
}
.theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate)
  .v-icon {
  color: #179d4e;
}

@media screen and (max-width: 767px) {
  .wrapperContent {
    padding: 15px 15px 4px;
  }
}
</style>
